import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { DEFAULT_ROUTER_FEATURENAME, NavigationActionTiming, provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideState } from '@ngrx/store';

import { CompanyModuleRouterFacade } from './store/facades/company-module-router.facade';
import { ModuleRouterFacade } from './store/facades/module-router-facade.service';
import { ModuleRouterSerializer } from './store/module-router-serializer';

export function provideModuleRouter(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(DEFAULT_ROUTER_FEATURENAME, routerReducer),
    provideRouterStore({
      serializer: ModuleRouterSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation,
    }),
    CompanyModuleRouterFacade,
    ModuleRouterFacade,
  ]);
}
